import * as React from "react";
const SvgDecreaseUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 8, viewBox: "0 0 10 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.53864 0L9.07729 7.86122H-1.66893e-05L4.53864 0Z", fill: "#F04B5B" }));
export default SvgDecreaseUp;
